/**
 * Created by houyulei on 2016/5/19.
 */
export const SET_VIEW_SCROLL_TOP = "SET_VIEW_SCROLL_TOP";
export const RESET_SCROLL_TOP = 'RESET_SCROLL_TOP';

export function setViewScrollTop(path, top) {
    return {type: SET_VIEW_SCROLL_TOP, path, top}
}

export function resetScrollTop() {
    return {type: RESET_SCROLL_TOP}
}


// WEBPACK FOOTER //
// ./components/redux/scrolltop/action.js